var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{attrs:{"primary":""},on:{"click":_vm.openSelfieState}},[_vm._v(" "+_vm._s(_vm.buttonCopy)+" "),(_vm.aiActiveState === _vm.aiStates.default && !_vm.fromSwitchModal)?_c('beta-badge',{attrs:{"is-in-button":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }